import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=86ec752a"
import script from "./PageFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PageFooter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=86ec752a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports